import { render, staticRenderFns } from "./PersContMark.vue?vue&type=template&id=6a360d09&scoped=true"
import script from "./PersContMark.vue?vue&type=script&lang=js"
export * from "./PersContMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a360d09",
  null
  
)

export default component.exports